module.exports = __webpack_public_path__ + "resources/img/mark_isms_lg.bf29e96ef15f36577f745b411eb02d8e.png";